// extracted by mini-css-extract-plugin
module.exports = {"rename":"Rename_rename__kH-xw","input":"Rename_input__3In84","icon":"Rename_icon__11tv4"};